import View from './View';

export { default as getTopBarMenuSectionStyles } from './styles';
export default View;
